const getAllDatesBefore = (endDate: Date) => {
    const result = []
    const currentDate = new Date()

    while (currentDate.getTime() <= endDate.getTime()) {
        result.push(new Date(currentDate.getTime()))
        currentDate.setDate(currentDate.getDate() + 1)
    }

    return result
}

// get all days after first sunday after provided date for number of provided months
const listOfDaysAfterFirstSunday = (startDate: Date | null, numMonths = 3) => {
    if (startDate === null) return []
    const result = []

    // Get the first Sunday after the provided start date
    const firstSunday = new Date(startDate.getTime())
    firstSunday.setDate(firstSunday.getDate() + (7 - firstSunday.getDay()))

    // Loop through the next `numMonths` months
    for (let i = 0; i < numMonths; i++) {
        // Add all dates after the first Sunday of this month
        const currentMonth = firstSunday.getMonth()
        while (firstSunday.getMonth() === currentMonth) {
            result.push(new Date(firstSunday.getTime()))
            firstSunday.setDate(firstSunday.getDate() + 1)
        }
    }

    return [...result, ...getAllDatesBefore(startDate)]
}

export default listOfDaysAfterFirstSunday
